import * as React from 'react';
import styled from '@emotion/styled';
import { keyframes } from '@emotion/react';

export interface IconSpinnerType {
    className?: string,
    spinnerColor?: string,
    type?: 'basic'
}

const svgAnimation = keyframes`
    0% {
        transform: rotateZ(0deg);
    }
    100% {
        transform: rotateZ(360deg);
    }
`;

const circleAnimationKey = keyframes`
    0%,
    25% {
        stroke-dashoffset: 280;
        transform: rotate(0);
    }
    50%,
    75% {
        stroke-dashoffset: 75;
        transform: rotate(45deg);
    }
    100% {
        stroke-dashoffset: 280;
        transform: rotate(360deg);
    }
`;

const SvgElement = styled('svg', { label: 'SvgElement' })<IconSpinnerType>`
    height: auto;
`;

const AnimationSvg = styled(SvgElement, { label: 'AnimationSvg' })`
     animation: 1s linear infinite ${svgAnimation};
`;

const CircleAnimation = styled('circle', { label: 'CircleAnimation' })`
    animation: 1.4s ease-in-out infinite both ${circleAnimationKey};
    fill: transparent;
    stroke: #020d16;
    stroke-linecap: square;
    stroke-dasharray: 283;
    stroke-dashoffset: 60;
    stroke-width: 8px;
    transform-origin: 50% 50%;
`;




export const Spinner = ({ className, spinnerColor, type }: IconSpinnerType): React.ReactElement => {

    if (type === 'basic') {
        return (
            <AnimationSvg  xmlns='http://www.w3.org/2000/svg' viewBox='0 0 100 100' className={className}>
                <CircleAnimation cx='50' cy='50' r='45' className={className}/>
            </AnimationSvg>
        );
    }

    return (
        <SvgElement fill={spinnerColor ?? '#ffffff'} className={className} xmlns='http://www.w3.org/2000/svg' width={100} height={20} viewBox='0 0 100 20'>
            <circle cx='16' cy='10' r='10' fill='#fill'>
                <animate attributeName='r' values='10;0;0;0;0' keyTimes='0;0.25;0.5;0.75;1' keySplines='0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1' calcMode='spline' dur='1s' repeatCount='indefinite' begin='0s'/>
                <animate attributeName='cx' values='84;84;84;84;84' keyTimes='0;0.25;0.5;0.75;1' keySplines='0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1' calcMode='spline' dur='1s' repeatCount='indefinite' begin='0s'/>
            </circle>
            <circle cx='16' cy='10' r='10' fill='#fill'>
                <animate attributeName='r' values='0;10;10;10;0' keyTimes='0;0.25;0.5;0.75;1' keySplines='0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1' calcMode='spline' dur='1s' repeatCount='indefinite' begin='-0.5s'/>
                <animate attributeName='cx' values='16;16;50;84;84' keyTimes='0;0.25;0.5;0.75;1' keySplines='0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1' calcMode='spline' dur='1s' repeatCount='indefinite' begin='-0.5s'/>
            </circle>
            <circle cx='16' cy='10' r='10' fill='#fill'>
                <animate attributeName='r' values='0;10;10;10;0' keyTimes='0;0.25;0.5;0.75;1' keySplines='0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1' calcMode='spline' dur='1s' repeatCount='indefinite' begin='-0.25s'/>
                <animate attributeName='cx' values='16;16;50;84;84' keyTimes='0;0.25;0.5;0.75;1' keySplines='0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1' calcMode='spline' dur='1s' repeatCount='indefinite' begin='-0.25s'/>
            </circle>
            <circle cx='16' cy='10' r='10' fill='#fill'>
                <animate attributeName='r' values='0;10;10;10;0' keyTimes='0;0.25;0.5;0.75;1' keySplines='0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1' calcMode='spline' dur='1s' repeatCount='indefinite' begin='0s'/>
                <animate attributeName='cx' values='16;16;50;84;84' keyTimes='0;0.25;0.5;0.75;1' keySplines='0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1' calcMode='spline' dur='1s' repeatCount='indefinite' begin='0s'/>
            </circle>
            <circle cx='16' cy='10' r='10' fill='#fill'>
                <animate attributeName='r' values='0;0;10;10;10' keyTimes='0;0.25;0.5;0.75;1' keySplines='0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1' calcMode='spline' dur='1s' repeatCount='indefinite' begin='0s'/>
                <animate attributeName='cx' values='16;16;16;50;84' keyTimes='0;0.25;0.5;0.75;1' keySplines='0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1' calcMode='spline' dur='1s' repeatCount='indefinite' begin='0s'/>
            </circle>
        </SvgElement>
    );
};
